import { useContext } from "react";

import debug from "debug";

import { getLocale } from "@jti/fe-common/config";

import { LocaleContext } from "./contexts";

const log = debug("desjti:configProvider:useLocale");

export const useLocale = () => {
  try {
    const _locale = useContext(LocaleContext);
    if (!_locale) {
      throw Error("useLocale hook used outside of LocaleProvider");
    }
    return _locale;
  } catch (error) {
    if (error instanceof Error) {
      log(error.message);
    }
    return getLocale();
  }
};
